<template>
  <div class="labelManage">
    <div class="content">
      <div class="header_operation">
        <div>
          <el-button type="primary" size="small">新建标签</el-button>
          <el-button size="small">导出标签</el-button>
        </div>
        <div class="rgt">
          <el-select v-model="value" placeholder="请选择" size="small">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-input
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            v-model="input2"
            size="small">
          </el-input>
        </div>
      </div>
      <div class="">
        <template>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="date" label="日期" width="180">
            </el-table-column>
            <el-table-column prop="name" label="姓名" width="180">
            </el-table-column>
            <el-table-column prop="address" label="地址">
            </el-table-column>
          </el-table>
        </template>
      </div>
      <div class="bottom">
        <div class="operation">
          <el-checkbox v-model="checked">当页全选</el-checkbox>
          <el-button size="small" style="margin-left:10px;">批量删除</el-button>
        </div>
        <div class="changePage">
          <span>共0条，每页10条</span>
          <el-button icon="el-icon-arrow-left" size="small"></el-button>
          <el-button icon="el-icon-arrow-right" size="small"></el-button>
          <span>跳至</span>
          <el-input v-model="input" size="small" ></el-input>
          <span>页</span>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  name: "labelManage", // 用户导入
  data() {
    return {
      activeName: 'first',
      carData: [
        {
          color: "rgb(38, 159, 255)"
        },
        {
          color: "rgb(47, 174, 68)"
        }
      ],
      tableData: [
        
      ]
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};
</script>

<style lang="scss" scoped>
.labelManage {
  margin: 16px;
  background: #fff;
  min-height: 300px;
  .content {
    padding: 16px;
    .header_operation {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 10px;
      .rgt {
        .el-input, .el-select {
          width: 160px;
          margin-left: 15px;
        }
      }
    }
    .bottom {
      margin-top: 16px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    .changePage {
      text-align: right;
      span{
        margin: 0 10px;
      }
      .el-input {
        width: 40px;
      }
    }
  }
}
</style>

<style lang="scss">
.labelManage {
  .el-table th, .el-table tr {
    background-color: #f2f2f2 !important;
  }
}
</style>
